<!-- eslint-disable @angular-eslint/template/no-inline-styles -->
<div class="w-full min-h-screen bg-background flex md:items-center md:justify-center p-4 md:p-[5%]">
  <!-- Card -->
  <div
    class="w-full max-w-[900px] overflow-hidden bg-white rounded-3xl shadow-md flex flex-col md:flex-row min-h-[calc(100vh-2rem)] md:min-h-0"
  >
    <!-- LEFT SIDE -->
    <div
      class="hidden md:flex md:w-1/2 relative items-center justify-center"
      style="background-color: #106eb8"
    >
      <img
        class="absolute inset-0 w-full h-full object-cover opacity-20"
        [src]="
          featureImageUrl()
            ? featureImageUrl()
            : 'https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0?q=80&w=2187'
        "
        alt=""
      />
    </div>

    <!-- RIGHT SIDE -->
    <div class="flex md:w-1/2 flex-col px-6 py-8 md:py-[65px] flex-1">
      <div class="w-full max-w-md mx-auto flex flex-col h-full">
        <!-- LOGO -->
        <div class="flex flex-col items-center">
          <img [src]="companyLogoUrl()" alt="logo" class="h-9 w-auto" />
        </div>

        <!-- FORM -->
        <form [formGroup]="signInForm" (ngSubmit)="onSubmit()" class="flex flex-col flex-1">
          <!-- BLOQUE CENTRADO -->
          <div class="flex flex-col justify-center flex-1">
            <!-- BIENVENIDA -->
            <div class="mt-6 text-center">
              <h2 class="text-[24px] font-bold">
                {{ 'SHARED.SIGNIN_SIGNIN.WELCOME_TITLE' | translate }}
              </h2>
              <p class="mt-2">
                {{ 'SHARED.SIGNIN_SIGNIN.WELCOME_MESSAGE' | translate }}
              </p>
            </div>

            <!-- INPUTS -->
            <div class="mt-8">
              <lib-custom-input
                [label]="'SHARED.SIGNIN_SIGNIN.EMAIL_LABEL' | translate"
                type="email"
                [placeholder]="'SHARED.SIGNIN_SIGNIN.EMAIL_PLACEHOLDER' | translate"
                name="email"
                formControlName="email"
                iconLeft="fa fa-envelope"
              ></lib-custom-input>

              <lib-custom-input
                [label]="'SHARED.SIGNIN_SIGNIN.PASSWORD_LABEL' | translate"
                type="password"
                [placeholder]="'SHARED.SIGNIN_SIGNIN.PASSWORD_PLACEHOLDER' | translate"
                name="password"
                formControlName="password"
                iconLeft="fas fa-lock"
              ></lib-custom-input>
            </div>
          </div>

          <!-- BOTONES ABAJO -->
          <div class="pt-8">
            <div class="flex flex-col md:flex-row gap-3 md:items-center">
              <!-- BOTÓN LOGIN -->
              <div class="w-full md:w-1/2 order-1 md:order-2">
                <lib-custom-button
                  class="w-full"
                  [label]="'SHARED.SIGNIN_SIGNIN.BUTTON' | translate"
                  type="submit"
                  variant="primary"
                  [loading]="loading()"
                  [disabled]="signInForm.invalid"
                  [fullWidth]="true"
                ></lib-custom-button>
              </div>

              <!-- FORGOT PASSWORD -->
              <div
                class="w-full md:w-1/2 flex items-center justify-center md:justify-start order-2 md:order-1"
              >
                <a
                  [routerLink]="forgotPasswordLink()"
                  class="font-medium text-[14px] text-error hover:underline text-center md:text-left w-full"
                >
                  {{ 'SHARED.SIGNIN_SIGNIN.FORGOT_PASSWORD_LINK' | translate }}
                </a>
              </div>
            </div>

            @if (showRegisterLink()) {
              <div class="text-center mt-6">
                <p class="text-[14px] text-gray-600">
                  {{ 'SHARED.SIGNIN_SIGNIN.NO_ACCOUNT_PROMPT' | translate }}
                  <a
                    [routerLink]="registerLink()"
                    class="font-medium text-blue-600 hover:text-blue-500"
                  >
                    {{ 'SHARED.SIGNIN_SIGNIN.REGISTER_LINK' | translate }}
                  </a>
                </p>
              </div>
            }
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
